// Chart.js v4 compatible chart configs

const footer = (tooltipItems) => {
  const footer = [];
  const sum = tooltipItems.reduce((current, next) => current + next.parsed.y, 0);
  if (tooltipItems.length === 2) {
    const a = Math.max(tooltipItems[0].parsed.y, tooltipItems[1].parsed.y);
    const b = Math.min(tooltipItems[0].parsed.y, tooltipItems[1].parsed.y);
    const BofA = (a && b ? ((b / a) * 100).toFixed(0) + '%' : '-');
    const AofSum = (sum > 0 ? ((a / sum) * 100).toFixed(0) + '%' : '-');
    footer.push('Low/High: ' + BofA);
    footer.push('High/Sum: ' + AofSum);
  }
  if (tooltipItems.length > 1) footer.push('Sum: ' + sum);
  return footer.length ? footer : '';
};

export const setOptions = (stacked = false, stackedX = false, customHeight = false, multiAxis = false) => ({
  maintainAspectRatio: !customHeight,
  interaction: { mode: 'index', intersect: false },
  plugins: {
    tooltip: { callbacks: { footer } },
  },
  scales: {
    x: { stacked: stackedX },
    y: {
      type: 'linear', position: 'left', stacked,
      beginAtZero: true, min: 0,
    },
    ...(multiAxis ? {
      y1: {
        type: 'linear', display: true, position: 'right', stacked,
        beginAtZero: true, min: 0,
        grid: { display: false },
      }
    } : {}),
  },
  animation: { duration: 0 },
});

export const setOptionsBarMultiColored = (stackedX = false) => ({
  indexAxis: 'y',
  scales: { x: { stacked: stackedX, beginAtZero: true, min: 0 } },
});

export const setOptionsStackedPercent = (stacked = true, stackedX = true, customHeight = false) => ({
  maintainAspectRatio: !customHeight,
  interaction: { mode: 'index', intersect: false },
  plugins: {
    tooltip: { callbacks: { footer } },
  },
  scales: {
    x: { stacked: stackedX },
    y: { type: 'linear', position: 'left', stacked, beginAtZero: true, min: 0, max: 100 },
  },
  animation: { duration: 0 },
});

const getDataSet = (label, data, adjustedColors, borderColors, stacked, fill, yAxisID) => ({
  label, data, backgroundColor: adjustedColors,
  borderColor: stacked ? '#ffffff' : borderColors,
  borderWidth: stacked ? 0.5 : 1.8,
  pointRadius: stacked ? 0 : 1,
  tension: stacked ? 0.1 : 0.3,
  fill, yAxisID: yAxisID || 'y',
});

const adjustColors = (colors, stacked) => colors.map(color => color + (stacked ? 'ff' : '80'));

export const chartConfig = (labels, dataSetsLabels, dataSetsData, colors, fill = false, stacked = false) => {
  const adjustedColors = adjustColors(colors, stacked);
  const datasets = dataSetsLabels.map((label, i) => getDataSet(label, dataSetsData[i], adjustedColors[i], colors[i], stacked, fill));
  return { labels, datasets };
};

export const chartConfigLineMultiAxis = (labels, dataSetsLabels, dataSetsData, colors, fill = false, stacked = false, yAxisID) => {
  const adjustedColors = adjustColors(colors, stacked);
  const datasets = dataSetsLabels.map((label, i) => getDataSet(label, dataSetsData[i], adjustedColors[i], colors[i], stacked, fill, yAxisID[i]));
  return { labels, datasets };
};

export const chartConfigMultiLinedStackedBar = (labels, dataSetsLabels, dataSetsData, colors, fill = false, stacked = false) => {
  const datasets = dataSetsLabels
    .map((label, i) => chartConfig(labels, label, dataSetsData[i], colors[i], fill, stacked))
    .map(cfg => cfg.datasets)
    .map((dataset, i) => dataset.map(data => ({ ...data, stack: `stack${i}` })))
    .flat(1);
  return { labels, datasets };
};

export const chartConfigBarMultiColored = (labels, dataSetsLabels, dataSetsData, colors, fill = false, stacked = false) => {
  const adjustedColors = adjustColors(colors, stacked);
  const datasets = dataSetsLabels.map((label, i) => getDataSet(label, dataSetsData[i], adjustedColors, colors, stacked, fill));
  return { labels, datasets };
};
